module.exports = require("express-basic-auth");